export default class DatatableInitter {
	constructor() {
		this.init();
	}

	init() {
		document.querySelectorAll('button[data-provide="datatableInit"]:not([data-datatable-init="1"])').forEach(function (button, key) {
			button.setAttribute('data-datatable-init', "1");
			let id = button.getAttribute('data-grid-target');

			button.addEventListener("click", (e) => {
				let datatable = document.getElementById(id);
				const reloadEvent = new Event("reload");
				datatable.dispatchEvent(reloadEvent);
			});
		});

		document.querySelectorAll('.modal[data-provide="datatableInit"]:not([data-datatable-init="1"])').forEach(function (modal, key) {
			modal.setAttribute('data-datatable-init', "1");
			let ids = [];

			if (modal.hasAttribute('data-grid-target')) {
				ids = [modal.getAttribute('data-grid-target')];
			} else if (modal.hasAttribute('data-grid-targets')) {
				ids = JSON.parse(modal.getAttribute('data-grid-targets'));
			}

			modal.addEventListener("shown.bs.modal", (e) => {
				Array.prototype.forEach.call(ids, async function (id, key) {
					let datatable = document.getElementById(id);
					const reloadEvent = new Event("reload");
					datatable.dispatchEvent(reloadEvent);

					await sleep(100);
				});
			});
		});
	}
}
